import { searchEntities } from '../../store/selectors/search';

export const selectItems = state => searchEntities(state, 'items', ['name', 'makeName', 'model', 'typeName', 'propertyNames']);

export const selectItemsForAssets = state => selectItems(state).map( item => ({ value: item.id,
  label: item.name + ((item.makeName || item.model) ? ' - ' + item.makeName + ' ' + item.model : '')}))

